export default "__VITE_ASSET__28ba8c06__"